import * as React from 'react';

import { IListItemProps } from '../../types/list_item_props';
import { IUser } from '../../types/user';
import { BlogListItem } from '../blog_list_item/blog_list_item';
import { ListItemContainer } from '../../containers/list_item';

interface IProps {
  currentUser: IUser;
  item: IListItemProps;
  saveScroll?(item: any): void;
  selectedItem?: IListItemProps;
  scrollComments(): void;
}

export class JournalListItem extends React.Component<IProps> {
  public render() {
    const type = this.props.item.attributes.type ||
                  this.props.item.type.toLowerCase();
    if (
        (type === 'article') ||
        (type === 'articles') ||
        (type === 'news')) {
      return (<ListItemContainer {...this.props} />);
    } else {
      return (<BlogListItem {...this.props} />);
    }
  }
}
